export const COMMON_TRANSLATE_KEYS = {
  RESERVATION: "reservation",
  CANCEL_RESERVATION: "cancel-reservation",
  RESERVATIONS: "reservations",
  COMPLEX: "complex",
  COMPLEXES: "complexes",
  FIELDS: "fields",
  FIELD: "field",
  GENERAL: "general",
  MY_FIELDS: "my_fields",
  SETTINGS: "settings",
  HELP: "help",
  ABOUT: "about",
  TERMS: "terms",
  QA: "q-and-a",
  BECOME_PARTNER: "become-partner",

  HERE: "here",
  SELECT: "select",
  FILTERS: "filters",

  DATE: "date",
  YES: "yes",
  NO: "no",
  UNTIL: "until",
  FROM: "from",
  FOR: "for",
  NUMBER_OF_WEEKS: "number-of-weeks",
  TIME: "time",
  DAY: "day",
  SELECT_DATE: "select-date",
  SELECT_TIME: "select-time",
  SELECT_DATE_ERROR: "select-date-error",
  SELECT_TIME_ERROR: "select-time-error",
  SELECT_DAYS_ERROR: "select-days-error",
  START_DATE_AFTER_END_DATE_ERROR: "start-date-after-end-date-error",
  INVALID_TIME_FORMAT_ERROR: "invalid-time-format-error",

  COMPLEX_SELECT: "complex-select",
  COMPLEX_SELECT_PLACEHOLDER: "complex-select-placeholder",
  FIELD_SELECT_PLACEHOLDER: "field-select-placeholder",
  SELECT_FIELD_ERROR: "select-field-error",
  OPTIONAL: "optional",
  NO_COMPLEXES: "no-complexes",
  NO_COMPLEXES_MAIN_PAGE: "no-complexes-main-page",
  NO_FIELDS: "no-fields",
  NO_FOUND_GROUPS: "no-found-groups",
  COMPLEX_HAS_NO_FIELDS: "complex-has-no-fields",
  FIELD_ADDED_SUCCESSFULLY: "field-add-successful",
  FIELD_UPDATED_SUCCESSFULLY: "field-update-successful",
  FIELD_ADD_ERROR: "field-add-error",
  FIELD_UPDATE_ERROR: "field-update-error",
  FIELD_DELETE_ERROR: "field-delete-error",
  COMPLEX_CREATED: "complex-created",
  CREATE_COMPLEX_ERROR: "create-complex-error",
  UPDATE_COMPLEX_MESSAGE: "update-complex-message",

  STATUS_SELECT_PLACEHOLDER: "status-select-placeholder",

  CHECK_IN: "check-in",
  CHECK_OUT: "check-out",
  FEATURED: "featured",
  LOG_IN: "login",
  LOG_OUT: "log-out",
  DELETE_ACCOUNT: "delete-account",
  DELETE_ACCOUNT_MODAL_TITLE: "delete-account-modal-title",
  DELETE_ACCOUNT_MODAL_TEXT: "delete-account-modal-text",

  ACCEPT: "accept",
  CANCEL: "cancel",
  DECLINE: "decline",
  ADD: "add",
  APPLY: "apply",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  DELETE_THIS_FIELD: "delete-this-field",
  DELETE_FIELD: "delete-field",
  DELETE_SURE: "delete-sure",
  UNAVAILABLE_FIELD: "unavailable-field",
  CHOOSE_FIELD_TO_DELETE: "choose-field-to-delete",
  DELETE_FIELD_CONFIRM: "delete-filed-confirmation-text",

  PENDING: "pending",
  ACCEPTED: "accepted",
  FREE: "free",
  DECLINED: "declined",
  DECLINED_BY_OWNER: "declined-by-owner",
  CANCELED_BY_PLAYER: "canceled-by-player",
  CANCELED: "canceled",
  UNKNOWN: "unknown",
  LOADING: "loading",
  FIELDS_LOADING: "loading-fields",
  TAKEN: "taken",
  NULLED: "nulled",

  DECLINE_RESERVATION_MODAL_TEXT: "decline-reservation-modal-text",
  CANCEL_RESERVATION_NOTICE: "cancel-reservation-notice",
  DECLINE_REASON: "decline-reason",
  DELETE_ACCOUNT_REASON: "delete-account-reason",
  ENTER_TEXT: "enter-text",
  ENTER_GROUP_NAME_AND_SELECT: "enter-group-name-and-select",
  SEE_MORE: "see-more",
  SEE_DETAILS: "see-details",
  SAVE: "save",
  BOOK: "book",
  CHANGE: "change",
  VIEW_FIELDS: "view-fields",
  VIEW_CALENDAR: "view-calendar",
  ADD_FIELD: "add-field",
  CREATE_COMPLEX: "create-complex",
  EDIT_COMPLEX: "edit-complex",
  EDIT_FIELD: "edit-field",
  EDIT_INFO: "edit-info",
  DELETE_COMPLEX: "delete-complex",
  BOOK_FIELD: "book-field",
  ALL_FIELDS: "all-fields",
  DELETE_COMPLEX_ADDITIONAL_TEXT: "delete-complex-additional-text",
  DELETE_FIELD_ADDITIONAL_TEXT: "delete-field-additional-text",

  FIELD_PAYMENT: "field-payment",
  GAME_TYPE: "game-type",
  RECURRING_DAYS: "recurring-days",
  END_RECURRING_DAY: "end-recurring-day",
  REPEAT: "repeat",
  WEEK_COUNT: "week-count",
  RECURRING: "recurring",
  CANCEL_RESERVATION_MODAL_TITLE: "cancel-reservation-modal-title",

  TEAM: "team",
  OWNER: "owner",
  COMPLEX_OWNER: "complex-owner",
  FIELD_OWNER: "field-owner",
  CAPTAIN: "captain",
  CAPTAIN_NAME: "captain-name",
  SECOND_CAPTAIN: "second-captain",
  RESERVED_FOR: "reserved-for",
  RESERVED_BY: "reserved-by",
  CREATED_AT: "reservation-created-at",
  CANCELLED_AT: "reservation-cancelled-at",

  // Sometimes we need to render only the private/public word. We use i18n context for bulgarian translations
  PRIVATE_GAME_CONTEXT: "private_game",
  PUBLIC_GAME_CONTEXT: "public_game",

  PRIVATE_GAME: "private-game",
  PUBLIC_GAME: "public-game",

  MONDAY_SHORT: "monday_short",
  TUESDAY_SHORT: "tuesday_short",
  WEDNESDAY_SHORT: "wednesday_short",
  THURSDAY_SHORT: "thursday_short",
  FRIDAY_SHORT: "friday_short",
  SATURDAY_SHORT: "saturday_short",
  SUNDAY_SHORT: "sunday_short",

  MONDAY_NORMAL: "monday_normal",
  TUESDAY_NORMAL: "tuesday_normal",
  WEDNESDAY_NORMAL: "wednesday_normal",
  THURSDAY_NORMAL: "thursday_normal",
  FRIDAY_NORMAL: "friday_normal",
  SATURDAY_NORMAL: "saturday_normal",
  SUNDAY_NORMAL: "sunday_normal",

  PLAYERS: "players",
  NICKNAME: "nickname",
  COUNTRY: "country",
  REGION: "region",
  DISTRICT: "district",
  ADDRESS: "address",
  CITY: "city",
  PHONE: "phone",
  PHONE_ERROR: "phone-error",
  EMAIL: "email",
  POSITION: "position",

  NAME: "name",
  PASSWORD: "password",
  PHONE_NUMBER: "phone-number",
  FIRST_NAME: "first-name",
  LAST_NAME: "last-name",
  DELETE_COMPLEX_CONFIRMATION_TEXT: "delete-complex-confirmation-text",
  CANCEL_DEADLINE_TEXT: "cancel-deadline-text",
  CANCEL_DEADLINE_UPDATE: "cancel-deadline-update",
  HOURS: "hours",
  NAME_OF_THE_PERSON: "name-of-the-person",
  PHONE_OF_THE_PERSON: "phone-of-the-person",

  DRAG_AND_DROP: "drag-and-drop",
  DROP_HERE: "drop-here",
  UPLOAD_FAILED: "upload-failed",
  PHOTOS_OF_THE_FIELD: "photos-of-the-field",
  PHOTOS_OF_THE_COMPLEX: "photos-of-the-complex",
  CHOOSE_A_COMPLEX: "choose-a-complex",
  CHOOSE_A_FIELD: "choose-a-field",
  NAME_OF_THE_FIELD: "name-of-the-field",
  NAME_OF_THE_COMPLEX: "name-of-the-complex",
  PRICE_PER_HOUR: "price-per-hour",
  PRICE: "price",
  CURRENCY: "currency",
  FIELD_LENGTH: "field-length",
  FIELD_WIDTH: "field-width",
  SIZE: "size",
  TYPE_OF_FLOORING: "type-of-flooring",
  IS_IT_COVERED: "is-it-covered",
  DOES_IT_HAVE_LIGHTING: "does-it-have-lighting",
  HEATING: "heating",
  TRIBUNES: "tribunes",
  PARKING: "parking",
  DRESSING_ROOM: "dressing-room",
  COFFEE_SHOP: "coffee-shop",
  SHOWERS: "showers",
  LIGHTING: "lighting",
  PROVIDE_BALLS: "provide-balls",
  PROVIDE_T_SHIRTS: "provide-t-shirts",
  CONTACT_PHONE: "contact-phone",
  CONTACT_CREATOR: "contact-creator",
  CONTACT_OWNER: "contact-owner",
  OPENING_HOURS: "opening-hours",
  CLOSING_HOURS: "closing-hours",
  HOURS_ERROR: "hours-error",
  WORKING_HOURS_REQUIRED_ERROR: "working-hours-required-error",
  OPENING_HOURS_ERROR: "opening-hours-error",
  CLOSING_HOURS_ERROR: "closing-hour-error",
  OPEN_CLOSE_HOURS_ERROR: "open-close-hours-error",
  ADDITIONAL_INFO: "additional-info",
  COMPLEX_INFO: "complex-info",
  FIELD_INFO: "field-info",
  INFO: "info",
  PROFILE: "profile",
  DESCRIPTION: "description",
  M: "m",
  RESERVE_FOR_ANOTHER_PERSON: "reserve-for-another-person",
  RECURRING_RESERVATION: "recurring-reservation",
  SINGLE_RESERVATION: "single-reservation",
  RESERVATION_OWNER_NAME: "reservation-owner-name",
  OWNER_PHONE_PLACEHOLDER: "owner-phone-placeholder",
  TEAM_NAME: "team-name",

  UPDATED_PASSWORD: "updated_she",
  NO_PASSWORD_SET: "no-password-set",
  INCORRECT_CREDS: "incorrect-creds",

  TIME_AGO_YEARS: "time-ago_years",
  TIME_AGO_MONTHS: "time-ago_months",
  TIME_AGO_WEEKS: "time-ago_weeks",
  TIME_AGO_DAYS: "time-ago_days",
  TIME_AGO_HOURS: "time-ago_hours",
  TIME_AGO_MINUTES: "time-ago_minutes",
  TIME_AGO_SECONDS: "time-ago_seconds",

  WELCOME: "welcome",
  TO_BOLARENA: "to-bolarena",
  FORGOT_PASSWORD: "forgot-password",
  LOGIN: "login",
  NO_ACCOUNT_CURRENTLY: "no-account-currently",
  SIGN_UP_NOW: "sign-up-now",
  OR_LOGIN_WITH: "or-login-with",

  ACCOUNT: "account",
  REPEAT_PASSWORD: "repeat-password",
  REGISTER_BUTTON: "register-button",
  ALREADY_HAVE_ACC: "already-have-acc",

  LOAD_MORE: "load-more",
  NO_NOTIFICATIONS: "no-notifications",
  OWNER_NOT_FOUND: "owner-not-found",
  EMAIL_SENDING_ERROR: "email-sending-error",
  RESERVATION_CANCELLED: "reservation-cancelled",
  RESERVATION_CREATED: "reservation-created",

  ENTER_CODE: "enter-code",
  RESET_PASS_TEXT: "reset-pass-text",
  NO_EMAIL: "no-email",
  SEND_AGAIN: "send-again",
  NEXT: "next",
  EXPIRED_CODE: "expired-code",
  RESET_PASSWORD: "reset-password",
  ENTER_NEW_PASS_TEXT: "enter-new-pass-text",
  RESET: "reset",

  UNEXPECTED_ERROR: "unexpected-error",

  NOTIFICATIONS_NOT_ALLOWED_TEXT: "not-allowed-notifications-text",
  ALLOW_NOTIFICATIONS: "allow",

  PAGE_NOT_FOUND: "page-not-found",

  NO_RESERVATIONS: "no-reservations",

  YOU: "you",
  DUPLICATE_FILE: "duplicate-file",
  FIELD_IS_UNAVAILABLE: "field-is-unavailable",
  CHANGE_LISTING_TYPE: "change-listing-type",

  PREFERENTIAL_PRICES: "preferential-prices",
  ADD_INTERVAL: "add-interval",
  PRICE_TIME_REQUIRED: "price-time-required",
  PRICE_HOURS_ERROR: "price-hours-error",
  START_END_HOURS_ERROR: "start-end-hours-error",
  APPLY_PRICE_MODAL_TITLE: "apply-price-modal-title",
  SELECT_COMPLEX_AND_CURRENCY: "select-complex-and-currency",
  OVERLAPPING_PRICE_INTERVAL: "overlapping-price-interval",
  OVERLAPPING_PRICE_MULTIPLE_INTERVALS: "overlapping-price-multiple-intervals",
  START_DATE: "start-date",
  PERIOD_START: "period-start",
  PERIOD_END: "period-end",
  PERIOD: "period",

  ABOUT_FIRST_PARAGRAPH: "about-first-paragraph",
  ABOUT_SECOND_PARAGRAPH: "about-second-paragraph",
  ABOUT_THIRD_PARAGRAPH: "about-third-paragraph",
  ABOUT_FOURTH_PARAGRAPH: "about-fourth-paragraph",

  PAGE_NOT_IMPLEMENTED: "page-not-implemented",

  CANCEL_RESERVATION_REASON_1: "cancel-reservation-reason-one",
  CANCEL_RESERVATION_REASON_2: "cancel-reservation-reason-two",
  CANCEL_RESERVATION_REASON_3: "cancel-reservation-reason-three",
  CANCEL_RESERVATION_REASON_4: "cancel-reservation-reason-four",
  CANCEL_RESERVATION_REASON_5: "cancel-reservation-reason-five",
  CANCEL_RESERVATION_REASON_PLACEHOLDER:
    "cancel-reservation-reason-placeholder",

  DELETE_ACCOUNT_REASON_1: "delete-account-reason-one",
  DELETE_ACCOUNT_REASON_2: "delete-account-reason-two",
  DELETE_ACCOUNT_REASON_3: "delete-account-reason-three",
  DELETE_ACCOUNT_REASON_4: "delete-account-reason-four",
  DELETE_PROFILE_LOADING_TEXT: "delete-profile-loading-text",

  CREATING: "creating",
  UPDATING: "updating",
  BOOKING_IN_PROGRESS: "booking-in-progress",
  CONFIRM: "confirm",
  CONFIRM_ALL: "confirm-all",
  CONFIRM_THIS: "confirm-this",
  CANCEL_RECURRING_RESERVATION_TEXT: "cancel-recurring-reservation-text",

  SIGNAL_SUBMITTED: "signal-submitted",
  SIGNAL_PROBLEM: "signal-problem",
  SIGNAL_PROBLEM_DESCRIPTION: "signal-problem-description",
  DESCRIBE_PROBLEM: "describe-problem",
  PROBLEM: "problem",
  PHOTOS: "photos",
  SEND: "send",
  SENDING: "sending",
  ALLOWED_FILE_TYPES: "allowed-file-types",
  MAX_FILE_LIMIT: "max-file-limit",

  CONTACT_US: "contact-us",
  CONTACT_US_DETAILS: "contact-us-details",
  SURNAME: "surname",
  MESSAGE: "message",
  MESSAGE_RECEIVED: "message-received-one",
  MESSAGES_RECEIVED: "message-received-many",

  TOO_LARGE_ENTITY: "too-large-entity",

  LOCATION_ON_MAP: "location-on-map",
  LOCATION_HINT: "location-hint",
  LOCATION_FIND_ADDRESS: "location-find-address",
  LOCATION_SEARCHING: "location-searching",
  LOCATION_CHECK_PIN: "location-check-pin",
  LOCATION_NOT_FOUND: "location-not-found",
  LOCATION_FILL_ADDRESS: "location-fill-address",
  LOCATION_NOT_SET: "location-not-set",
};
